/* esm.sh - @radix-ui/react-tooltip@1.2.16 */
export * from "/*@radix-ui/react-tooltip@1.2.16/esnext/react-tooltip.mjs";
